@if (leadingSlot(); as slot) {
  <span class="soft-ds-tab__slot">
    <ng-container *ngTemplateOutlet="slot.template!" />
  </span>
} @else if (icon(); as iconName) {
  <soft-ds-icon class="soft-ds-tab__icon" [name]="iconName" size="sm" />
}
<span class="soft-ds-tab__label ds-body-2-medium">
  @if (title(); as titleText) {
    {{ titleText }}
  }
  <ng-content select=":not([softSlot])" />
</span>
@if (trailingSlot(); as slot) {
  <span class="soft-ds-tab__slot">
    <ng-container *ngTemplateOutlet="slot.template!" />
  </span>
} @else if (badge() !== null) {
  <soft-ds-number-badge class="soft-ds-tab__badge">{{ badge() }}</soft-ds-number-badge>
}
